import { render, staticRenderFns } from "./topsongs.vue?vue&type=template&id=807e5e30&"
import script from "./topsongs.vue?vue&type=script&lang=js&"
export * from "./topsongs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports